import { isAxiosError } from "axios";

/**
 * バリデーションエラー（HTTP 400）のレスポンスから、ユーザーに表示するメッセージを取り出す。
 * バックエンド（Django REST framework）は `{ フィールド名: [メッセージ], nonFieldErrors: [メッセージ] }`
 * または `{ detail: メッセージ }` の形で返す（キーは apiClient により camelCase に変換済み）。
 * 400以外のエラーや想定外の形の場合は空配列を返す
 * @param error catch した値
 * @returns 表示するメッセージ（順序はレスポンスのキー順）
 */
export const extractApiValidationMessages = (error: unknown): string[] => {
  if (!isAxiosError(error) || error.response?.status !== 400) return [];
  const data: unknown = error.response.data;
  if (data === null || typeof data !== "object") return [];

  return Object.values(data as Record<string, unknown>).flatMap((value) => {
    if (typeof value === "string") return [value];
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === "string");
    }
    return [];
  });
};
